import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RowAddButton from '@/components/buttons/RowAddButton';
import { addDictionaryField } from '../../dictionaries/actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldTableFooter = ({
  category,
  code,
  showEmptyRow,
  disabled,
  colSpan,
  template,
}) => (
  <Table.Footer fullWidth>
    <Table.Row>
      <Table.HeaderCell colSpan={colSpan}>
        <RowAddButton
          entity="dictionary"
          onClick={() => showEmptyRow(category, code, template)}
          disabled={disabled}
        />
      </Table.HeaderCell>
    </Table.Row>
  </Table.Footer>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps);
  return ({ disabled: !editable, template });
};

const mapDispatchToProps = {
  showEmptyRow: addDictionaryField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldTableFooter);
